import React, {useState, useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import { Icon, Label, Popup, Modal, Button, Form, Input } from 'semantic-ui-react'
import {WindowURL,WindowLocation,WindowReload} from '../../config/settings'
import Alertmessage from '../../config/alert'
import {loginvalidate} from './validations'

export default function CustomerLogin(props) {

  function AddCustomClassBody(){
    document.body.classList.add("application");
  }

  const [alert,setalert] = useState(false);
  const [Alertcontent,setAlertcontent] = useState({});
  function Alertclose(){setalert(false);}
  function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
  function Alertdelete(data){
    if(data.delete==true){
      //console.log(data.id);
    }
  }

  const [seen,setseen] = useState(false);
  const [state,setstate] = useState({
		username:'',
		password:''
	});

	function handleSubmitForm(values, props){
		//props.resetForm();
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','login');
		formData.append('info',JSON.stringify(values));
		axios.post('/client/login/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Successfully login',html:"This won't take long, please wait..."}});
				setalert(true);
				setTimeout(function() {WindowLocation('/client/account');},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Login Error!',html:"Please enter your valid login credentials.",footer:'yes'}});
				setalert(true);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors.",footer:'yes'}});
			setalert(true);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
      setalert(true);
      setTimeout(function() {setalert(false);},2000);
		});
	}


  function login(){
    let formData = new FormData();
    formData.append('type','IsLogin');
    axios.post('/client/login/http.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj>0){
          setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Already login',html:"You will redirected to your account, please wait..."}});
  				setalert(true);
  				setTimeout(function() {WindowLocation('/client/account');},3000);
  				return false;
        }
    })
    .catch(function (error){
      setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
      setTimeout(function() {setalert(false);},2000);
    });
  }


  useEffect(()=>{
    AddCustomClassBody();
    login();
  },[]);

	return (
      <Formik
          initialValues={state}
          validationSchema={loginvalidate}
          onSubmit={handleSubmitForm}
          render={formProps => {
          const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps
          return(
          <Form>
            {alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
            <div className="member-login-wrapper">
              <div className="member-login-container">
                <div>

                  <div className="member-login-header">
                    <div><i className="uil-folder-lock"></i></div>
                    <div>
                       <h1>Client Secure Login</h1>
                       <p>If you are already a member please login below.</p>
                    </div>
                  </div>

                  <Form.Group widths='equal'>
                       <Field name="username">
                       {({ field, form }) => (
                           <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                             <label>Username</label>
                             <Input fluid {...field} onChange={handleChange}/>
                             { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i class="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                           </Form.Field>
                       )}
                       </Field>
                   </Form.Group>
                   <Form.Group widths='equal'>
                     <Field name="password">
                     {({ field, form }) => (
                         <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                           <label>Password</label>
                           <Input
                             type={seen==true?'text':'password'}
                             icon={<Icon name={seen==true?'eye':'eye slash'} link onClick={()=>setseen(seen==true?false:true)}/>}
                             fluid {...field}
                             onChange={handleChange}/>
                           { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i class="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                         </Form.Field>
                     )}
                     </Field>
                   </Form.Group>

                   <div className="member-button">
                      <Button className='primary' icon='lock' content='LOGIN' onClick={handleSubmit}/>
                   </div>


                </div>

                <div>
                  <div className="member-login-header">
                    <div><i className="uil-user"></i></div>
                    <div>
                       <h1>NOT A MEMBER YET?</h1>
                       <p>Open an account and gain membership access.</p>
                    </div>
                  </div>
                  <div className="member-button">
                     <Button className='secondary' icon='uil-users-alt' content='OPEN ACCOUNT' href={WindowURL('/')}/>
                     {/*<Button className='primary' icon='uil-file-download' content='DOWNLOAD APPLICATION'/>*/}
                  </div>
                </div>


              </div>
            </div>
          </Form>
       )}}/>
	)
}
